import React, { useEffect, useState } from "react";
import classes from "./FeedbackPopup.module.css"
import { useSelector } from "react-redux";
import { MAX_RETRIES } from "../../Questionnaire/QuestionnaireViewer";
import { FeedbackTypesEnum } from "../../../models/FeedbackTypesEnum";

const FeedbackPopup = ({ type, attempts, data }) => {

    const { texts } = useSelector(state => state.translate);

    const types = {
        correct: {
            content: <div>{texts.correctAnswer}</div>,
        },
        inCorrect: {
            content: <div>{data.options && data.multiple ? texts.wrongAnsCheckList : texts.wrongAnswer}</div>,
        },
        maxRetries: {
            content: <div>{texts.maxRetries}</div>,
        },
        accepted: {
            content: <div>{texts.answerRecived}</div>,
        }
    }
    return <>

        <div className={`${classes.Popup}`}>
            <div className={classes.PopupContent}>
                <div>{types[type]?.content}</div>
               {!data.longAnswer && <div className={classes.Attempts}>{(type === FeedbackTypesEnum.InCorrect || type === FeedbackTypesEnum.Correct) && `${texts[`try-${type}`]} ${attempts}/${MAX_RETRIES + 1}`}</div>}
            </div>
        </div>
    </>
}
export default FeedbackPopup;